import { ToggleSwitch } from "../components/ToggleSwitch";

export function NotificationsSection({
  receiveEmailAlerts,
  receiveReports,
  handleSettingChange,
  setReceiveEmailAlerts,
  setReceiveReports,
}) {
  return (
    <div className="w-full">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between w-full gap-3 p-3 border border-[#DDDDDD] rounded">
        <div className="flex flex-col gap-1">
          <span className="text-[16px] font-bold">
            Receive Alerts Via Email
          </span>
          <span className="text-[16px] opacity-50">
            Selecting "on" means you'll receive emails if a student types a word
            like "hurt"
          </span>
        </div>
        <div className="ml-auto">
          <ToggleSwitch
            checked={receiveEmailAlerts}
            onCheckedChange={(val) =>
              handleSettingChange(
                "receiveEmailAlerts",
                val,
                setReceiveEmailAlerts,
              )
            }
          />
        </div>
      </div>
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between w-full gap-3 p-3 border border-[#DDDDDD] rounded mt-4">
        <div className="flex flex-col gap-1">
          <span className="text-[16px] font-bold">
            Receive Reports Via Email
          </span>
          <span className="text-[16px] opacity-50">
            Selecting "on" means you'll receive periodic emails highlighting
            celebrations and important data
          </span>
        </div>
        <div className="ml-auto">
          <ToggleSwitch
            checked={receiveReports}
            onCheckedChange={(val) =>
              handleSettingChange("receiveReports", val, setReceiveReports)
            }
          />
        </div>
      </div>
    </div>
  );
}
